<div class="content-area">
  <div class="clr-row">
    <div class="clr-col-12 align-items-center d-flex">
      <app-back-button [forceShow]="true" [routerLink]="['/activities']"></app-back-button>
      <h1 class="d-inline-block mt-0 ml-3">ABChest</h1>
      <h3 class="d-inline-block ml-3">(jocul merge doar pe device-uri cu tastatură fizică)</h3>
    </div>
    <div class="clr-col-12">
      <iframe src="https://raduanastase.com/fb-api/_extra/abchest/"></iframe>
    </div>
  </div>
</div>
